// components/Desktop/Components/Safe3.js
import React from 'react';
import styles from './Safe3.module.css';

// Replace with your actual image paths
import asset1 from '../../../assets/safe3-asset1.png';
import asset2 from '../../../assets/safe3-asset2.png';
import asset3 from '../../../assets/safe3-asset3.png';

const Safe3 = () => {
  return (
    <section className={styles.safe3Section}>
        <h2 className={styles.topLine}>Taking it a step further than self written bios,<br/> we created Friend opinions</h2> 
        <h2 className={styles.middleText}>Get a better sense of who a person is by seeing them <br/>through the eyes of people who already know them</h2> {/* Replace with your text */}
        <h1 className={styles.bottomLine}>Friend opinions</h1>

      {/* Right Column (Images) */}
        <img src={asset1} alt="Asset 1" className={styles.topImage} />
        <div className={styles.bottomImages}>
          <img src={asset2} alt="Asset 2" className={styles.bottomImage1} />
          <img src={asset3} alt="Asset 3" className={styles.bottomImage2} />
        </div>
    </section>
  );
};

export default Safe3;
